<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-10">
      <legend class="usa-legend usa-legend--large">XTOS Single Shipment Reports</legend>
    </div>
  </div>
  @if (xtosShipmentDetailVM$ | async; as vm) {
    <div>
      <div>
        <app-xtos-shipment
          [carriers]="vm[0]"
          [states]="vm[2]"
          [xtosShipment]="selectedExtendedStorage$ | async"
          [isXTOSShipmentSelected]="isXTOSShipmentSelected"
          (saveXTOSShipment)="saveXTOSShipment($event)"
          [saveInProgress]="this.saveXTOSShipment$"
          (deleteXTOSShipment)="deleteXTOSShipment($event)"
        ></app-xtos-shipment>
      </div>
    </div>
  }
</div>
<!-- <ng-container *ngIf="saveXTOSShipment$ | async"></ng-container> -->
@if (deleteXTOSShipment$ | async) {
}
